import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: '政务公开系统',
  //   component: () => import('../views/in工业和信息化部政府信息公开系统ion-bulletin/zwgk-door')
  // },
  {
    path: '/',
    name: '政府信息公开申请',
    component: () => import('../views/information-bulletin/information-text')
  },
  {
    path: '/select-result-table',
    name: '申请进度查询',
    component: () => import('../views/progress-select/select-result-table.vue')
  },
  {
    path: '/apply-table-write',
    name: '表格填写',
    component: () => import('../views/apply-public/apply-table-write.vue')
  },
  {
    path: '/select-result',
    name: '申请查询',
    component: () => import('../views/progress-select/select-result.vue')
  },
  {
    path: '/apply-submit',
    name: '提交成功',
    component: () => import('../views/apply-public/apply-submit.vue')
  },
  {
    path: '/apply-table-view',
    name: '查看申请表格',
    component: () => import('../views/apply-public/apply-table-view.vue')
  },
  {
    path: '/select-progress',
    name: '查看进度',
    component: () => import('../views/progress-select/select-progress.vue')
  },
  {
    path: '/zwgk-door',
    name: '热点信息',
    component: () => import('../views/information-bulletin/zwgk-door')
  },
  {
    path: '/select-result-view',
    name: '查看申请详情',
    component: () => import('../views/progress-select/select-result-view.vue')
  },
  {
    path: '/zwgk-door-textContent',
    name: '查看文章详情内容',
    component: () => import('../views/information-bulletin/zwgk-door-textContent')
  },
  {
    path: '/zwgk-no-access',
    name: '维护中无法访问',
    component: () => import('../views/no-access')
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
